import React from 'react';

const CTA: React.FC = () => {
  return (
    <section className="section-padding bg-brand-orange relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.1),transparent_50%)]"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_70%_80%,rgba(255,255,255,0.1),transparent_50%)]"></div>
      </div>
      
      {/* Floating Elements */}
      <div className="absolute top-10 left-20 w-20 h-20 border border-white/20 rounded-full animate-float"></div>
      <div className="absolute top-32 right-32 w-16 h-16 border border-white/20 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
      <div className="absolute bottom-20 left-1/3 w-12 h-12 border border-white/20 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
      
      <div className="container-custom text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl lg:text-6xl font-medium text-white mb-6 leading-tight">
            Ready to Transform
            <span className="block">
              Your Brand?
            </span>
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            Let's create strategic, story-driven brands that connect, inspire, and lead change through bold visuals and unforgettable experiences.
          </p>
          
        </div>
      </div>
    </section>
  );
};

export default CTA;
